<template>
  <b-card>
    <ErrorMessage :status="infoApiStatus.status" :customMessage="infoApiStatus.customMessage" />
    <b-container class="achievement-header" v-if="isDataSet">
      <b-row align-h="between">
        <b-col cols="12" sm="7" lg="9">
          <h1 class="achievement-title">{{selectedAchievement.title}}
            <span v-if="isDraft" style="font-size: 14px">(下書き)</span>
            &nbsp;
            <b-badge style="font-size: 14px">{{ selectedAchievement.display_achievent_type }}</b-badge>
          </h1>
        </b-col>
        <b-col cols="12" sm="5" lg="3">
          <div class="date-area">
            <span class="create-date">作成日：{{ displayDate(selectedAchievement.created_at) }}</span>
            <template >
              <span v-if="selectedAchievement.created_at !== selectedAchievement.updated_at" class="update-date">
              <br />更新日：{{ displayDate(selectedAchievement.updated_at) }}
              <br /></span>
            </template>
          </div>
        </b-col>
      </b-row>
      <b-row v-if="isAdmin" class="student-info-area">
        <b-col>
          <span>修了生名：{{ selectedAchievement.user_name }}</span>
          <br />
          <span>修了年度：{{ selectedAchievement.display_program_time }}</span>
        </b-col>
      </b-row>
      <b-row class="issue-date">
        <b-col>日時：{{ displayDate(selectedAchievement.issued_at) }}</b-col>
      </b-row>
      <hr />
    </b-container>
    <b-container class="achievement-body">
      <b-row v-if="isDataSet">
        <b-col>
          <section v-if="selectedAchievement.detail !== ''" v-text="selectedAchievement.detail" />
          <section v-else v-text="'未設定'" />
          <hr />
          <section class="link-area">
            <h6>関連リンク</h6>
            <b-link v-if="selectedAchievement.link" :href="sanitizedUrl" target="_brank">{{ selectedAchievement.link }}</b-link>
            <span v-else>未設定</span>
          </section>
          <hr />
          <section class="file-area">
            <h6>添付ファイル</h6>
            <attached-file-list v-if="selectedAchievement.files.length" :fileList="selectedAchievement.files" @click="handleClickFile" />
            <span v-else>未設定</span>
          </section>
        </b-col>
      </b-row>
    </b-container>
  </b-card>
</template>

<script>
import AttachedFileList from './AttachedFileList'
import ErrorMessage from '@/components/ErrorMessage.vue'
import { sanitizeUrl } from '@braintree/sanitize-url'
import { mapState, mapGetters } from 'vuex'
import api from '@/api'
import dayjs from 'dayjs'
import { createFileDownloadLink } from '@/transformer/achievement'

export default {
  name: 'AchievementDetail',

  components: {
    AttachedFileList,
    ErrorMessage
  },

  props: {
    isAdmin: {
      default() {
        return false
      }
    }
  },

  computed: {
    ...mapState({
      achievementTypes: state => state.Achievement.achievementTypes,
      infoApiStatus: state => state.Achievement.infoApiStatus
    }),
    ...mapGetters('Achievement', ['selectedAchievement']),
    isDraft() {
      return this.selectedAchievement.is_draft === '1'
    },
    isDataSet() {
      return this.infoApiStatus.status === 200
    },
    sanitizedUrl() {
      return sanitizeUrl(this.selectedAchievement.link)
    }
  },

  methods: {
    handleClickFile(fileId) {
      api.achievement.downloadFile(fileId).then((res) => {
        const downloadLink = createFileDownloadLink(res)
        downloadLink.click()
      }).catch(() => {
        this.$root.$bvToast.toast(
          'ファイルのダウンロードに失敗しました。ファイルがすでに削除されている可能性があります。',
          {
            variant: 'danger',
            toaster: 'b-toaster-top-center',
            noAutoHide: true
          })
      })
    },
    displayDate(date) {
      if (!date) {
        return '未設定'
      }
      return dayjs(date).format('YYYY年M月D日')
    }
  }
}
</script>

<style scoped>
.achievement-title {
  font-size: 24px;
  display: inline-block;
}
.student-info-area {
  font-size: 12px;
  padding-top: 5px;
  padding-bottom: 5px;
  margin-top: 5px;
  margin-bottom: 5px;
}

.issue-date {
  font-size: 12px;
}

.date-area {
  font-size: 12px;
  display: inline-block;
  height: 24px;
}
.achievement-header{
  padding: 5px;
}
.achievement-body {
  white-space: pre-wrap;
  padding: 5px;
  font-size: 14px;
}
</style>
